import { useEffect, useRef } from 'react';
import { animate, useInView } from 'motion/react';
import workshops from '../assets/images/workshops.png';
import mice from '../assets/images/mice.png';
import grouppe from '../assets/images/grouppe.png';
import calender from '../assets/images/calender.png';
import AnimatedSection, { AnimatedGroup, AnimatedItem } from './AnimatedSection';

const stats = [
    {
        icon: workshops,
        label: 'عدد ورش العمل',
        value: '5',
    },
    {
        icon: mice,
        label: 'عدد المتحدثين',
        value: '9',
    },
    {
        icon: grouppe,
        label: 'الحضور المتوقع',
        value: '2000',
    },
    {
        icon: calender,
        label: 'موعد المؤتمر',
        value: '13 سبتمبر 2026',
    },
];

const StatValue = ({ value }) => {
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true, amount: 0.6 });
    const numericValue = Number(value);
    const isNumeric = Number.isFinite(numericValue);

    useEffect(() => {
        if (!isNumeric || !isInView || !ref.current) return;

        const controls = animate(0, numericValue, {
            duration: 1.8,
            ease: [0.22, 1, 0.36, 1],
            onUpdate: (latest) => {
                if (ref.current) {
                    ref.current.textContent = Math.round(latest).toLocaleString('en-US');
                }
            },
        });

        return () => controls.stop();
    }, [isInView, isNumeric, numericValue]);

    return (
        <p ref={ref} className="text-lg font-bold">
            {isNumeric ? 0 : value}
        </p>
    );
};

const ConferenceStats = () => {
    return (
        <AnimatedSection className="bg-[#3E83B9] text-white py-12 px-4" direction="none">
            <AnimatedGroup className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 text-center">
                {stats.map((stat) => (
                    <AnimatedItem key={stat.label} className="flex flex-col items-center justify-center">
                        <div className="w-14 h-14 mb-4 flex items-center justify-center">
                            <img src={stat.icon} alt={stat.label} />
                        </div>
                        <h3 className="text-lg font-bold mb-2">{stat.label}</h3>
                        <StatValue value={stat.value} />
                    </AnimatedItem>
                ))}
            </AnimatedGroup>
        </AnimatedSection>
    );
};

export default ConferenceStats;
